import api from './client';
import type { ApiResponse, Pagination } from '../types/common';
import type { Notification, NotificationPreference } from '../types/notifications';

export const notificationsApi = {
  list: (params?: { page?: number; limit?: number; unreadOnly?: boolean }) =>
    api.get<ApiResponse<{ notifications: Notification[]; pagination: Pagination }>>('/notifications', { params }),

  getUnreadCount: () =>
    api.get<ApiResponse<{ count: number }>>('/notifications/unread-count'),

  markAsRead: (id: string) =>
    api.patch<ApiResponse<void>>(`/notifications/${id}/read`),

  markAllAsRead: () =>
    api.post<ApiResponse<{ message: string; count: number }>>('/notifications/read-all'),

  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`/notifications/${id}`),

  getPreferences: () =>
    api.get<ApiResponse<{ preferences: NotificationPreference }>>('/notifications/preferences'),

  updatePreferences: (data: Partial<Omit<NotificationPreference, 'id' | 'userId'>>) =>
    api.patch<ApiResponse<{ preferences: NotificationPreference }>>('/notifications/preferences', data),
};
